import { Stack } from '@mui/material';
import { getSelectedBoardId } from "@common-reducers/BoardsSelectors";
import { DBWorkloadThunks, workloadSelectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { useMemo } from 'react';
import BTCheckboxList from "../checkbox-list/bt-checkbox-list";
import { getDynamicColumnListForBTCheckbox } from '@common-reducers/TaskSelectors';
import { TaskColumn } from '@common-models/task-column';

export default function WorkloadIncludedColumnsDialog() {
    /// picker selector drop down menu ///
    const dispatch = useAppDispatch()
    const currentBoardId = useAppSelector(getSelectedBoardId)
    const currentBoardView = useAppSelector((state) => state.TasksReducer.currentBoardView)
    const [workload] = useAppSelector((state) => workloadSelectByQuery(state.DBWorkloadReducer, { boardId: currentBoardId, _id: currentBoardView.id }));
    const columnList = useAppSelector((state) => getDynamicColumnListForBTCheckbox(state, 'workload'))
    const includedColumns = useMemo(() => (workload && workload?.includedColumns ? workload?.includedColumns : {}), [workload])



    const handleCheckBoxChange = (value: boolean, column: TaskColumn) => {
        const colKey = column._id ?? '';
        if (!workload) return;
        dispatch(
            DBWorkloadThunks.patch({
                entity: {
                    _id: workload._id,
                    includedColumns: {
                        ...workload.includedColumns,
                        [colKey]: value,
                    }
                }
            })
        )
    }

    function handleAllCheckBoxChange(value: boolean) {
        if (!workload) return;
        const newIncludedColumnsList = columnList.map((column) => ({
            id: column._id, boolean: value
        }))
        let newIncludedColumns: Record<string, boolean> = {}
        for (let i in newIncludedColumnsList) {
            const entry = newIncludedColumnsList[i];
            if (entry.id) {
                newIncludedColumns = {
                    ...newIncludedColumns,
                    [entry.id]: entry.boolean
                }
            }
        }

        dispatch(
            DBWorkloadThunks.patch({
                entity: {
                    _id: workload._id,
                    includedColumns: newIncludedColumns,
                }
            })
        )
    }

    const isChecked = (column: TaskColumn) => (includedColumns[column._id ?? ''] ?? false)

    const isCheckedRecord: Record<string, boolean> = columnList.reduce<Record<string, boolean>>((isCheckedRecord, column) => ({
        ...isCheckedRecord,
        [column._id ?? '']: isChecked(column)
    }), {});

    return (
        <Stack direction="column" >
            <BTCheckboxList
                isCheckedRecord={isCheckedRecord}
                columnList={columnList}
                handleCheckBoxChange={handleCheckBoxChange}
                handleAllCheckBoxChange={handleAllCheckBoxChange}
            />
        </Stack>
    )
}   